<template>
  <div
    id="App"
    class="min-h-screen flex flex-col items-center px-4 py-10 sm:py-14"
  >
    <main class="w-full max-w-3xl flex flex-col gap-10 sm:gap-12">
      <Neon />
      <Bitcoin />
    </main>
    <p class="mt-auto pt-10 text-center text-xs text-gray-500">
      Interactive demo — data shown for presentation only.
    </p>
  </div>
</template>

<script>
import Neon from "./components/Neon.vue";
import Bitcoin from "./components/Bitcoin.vue";

export default {
  name: "App",
  components: {
    Neon,
    Bitcoin,
  },
};
</script>

<style>
#app {
  min-height: 100vh;
}
</style>
